import { useState } from 'react';
import { StepOne, StepTwo } from './widgets';

const StepEnum = {
  First: 1,
  Second: 2,
} as const;
type StepEnum = (typeof StepEnum)[keyof typeof StepEnum];

export const Register = () => {
  const [step, setStep] = useState<StepEnum>(StepEnum.First);

  return (
    <>
      {step === StepEnum.First && <StepOne onSubmit={() => setStep(StepEnum.Second)} />}
      {step === StepEnum.Second && <StepTwo />}
    </>
  );
};
